/**
 * Utility for xhrs
 * @author Prajwalit Bhopale <prajwalit@helpshift.com>
 * @created Feb 11, 2015
 * @module utils/xhr
 */

import sessionHelpers from "extras/sessionHelpers";

/* eslint-disable max-len */
// From http://yuilibrary.com/yui/docs/api/files/querystring_js_querystring-stringify-simple.js.html
/* eslint-enable max-len */
var queryStringify = function (obj) {
  var qs = [],
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      qs.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
    }
  }
  return qs.join("&");
};

/**
 * check if given status indicates success or not.
 */
var isSuccess = function (statusCode) {
  return statusCode >= 200 && statusCode < 300;
};

export default function (params) {
  var x = new XMLHttpRequest();
  var url = params.route;
  var formParams;
  params.method = params.method || "GET";
  params.parse = typeof params.parse === "boolean" ? params.parse : true;

  if (params.method === "GET" && params.data) {
    url += "?" + queryStringify(params.data);
  }

  x.open(params.method, url, true);

  if (["POST", "DELETE", "PUT", "PATCH"].includes(params.method)) {
    params.data = params.data || {};
    params.data._csrf_token = window.HSM ? HSM.csrf : HS.csrf;
    formParams = queryStringify(params.data);
    x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  }

  x.setRequestHeader("X-Requested-With", "XMLHttpRequest");

  if (!params.ignoreWorkzone && window.WORKZONE_PUBLISH_ID) {
    x.setRequestHeader("x-hs-workzone-publish-id", window.WORKZONE_PUBLISH_ID);
  }

  x.onreadystatechange = function () {
    var response;

    if (x.readyState === 4) {
      if (isSuccess(x.status) && x.responseText && params.onSuccess) {
        response = params.parse ? JSON.parse(x.responseText) : x.responseText;
        params.onSuccess.call(params.context || null, response, x, x.status);
      } else if (!isSuccess(x.status)) {
        if (x.status === 0) {
          if (params.onAbort) {
            params.onAbort.call(params.context || null, x, x.status);
          }
        } else if (sessionHelpers.hasUserSessionTimedOut(x)) {
          sessionHelpers.onUserSessionTimeout();
        } else if (params.onFailure) {
          params.onFailure.call(params.context || null, x, x.status);
        }
      }
      // @TODO this is a temporary fix to handle response code 204
      // make a permanent solution to handle this
      if (params.onEnd) {
        params.onEnd.call(params.context, x.responseText, x);
      }
    }
  };

  x.send(formParams);

  return x;
}
